<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center" class="mb-10">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="5">

              <h1 class="font-weight-light responsive-display">Vegye fel velem a kapcsolatot!</h1>
              <br/>
              <h3 class="font-weight-light responsive-display2 mt-3">
                <strong>Köszönöm hogy felkereste weboldalamat!</strong>
                <br/>
                Amennyiben felkeltettem az érdeklődését, az alábbi elérhetőségek egyikén felveheti velem a kapcsolatot.
              </h3>
              <h3 class="font-weight-light responsive-display2 mt-3">
                Telefonszám: <strong>+36706702226</strong>
              </h3>
              <br/>
              <h3 class="font-weight-light responsive-display2">
                E-mail cím: <strong>vendz97618@gmail.com</strong>
              </h3>
              <br/>
              <h3 class="font-weight-light responsive-display2">Lokációt illetően <strong>Mogyoród</strong> térségében tevékenykedem</h3>
            </v-col>
            <v-col cols="12" sm="7" align="center" justify="center">
              <div class="mt-10" style="height: 500px;">
                <iframe
                  src="https://www.google.com/maps/d/u/0/embed?mid=1Tx7wjfKj3kRU_f5pglXempW6tKYryjQ&ehbc=2E312F"
                  style="border: 0; width: 80%; height: 100%;"
                  loading="lazy"
                ></iframe>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
  </section>
</template>

<script>

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    }
  }),
};
</script>

<style scoped>
#contact{
  background-color: #8A8C99;
}
.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
.responsive-h1 {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.responsive-display {
  font-size: 2rem; /* Alapértelmezett betűméret */
}

@media (min-width: 600px) {
  .responsive-display {
    font-size: 2.5rem; /* Közepes képernyő */
  }
}

@media (min-width: 960px) {
  .responsive-display {
    font-size: 2.75rem; /* Nagy képernyő */
  }
}

@media (min-width: 1264px) {
  .responsive-display {
    font-size: 3rem; /* Extra nagy képernyő */
  }
}

.responsive-display2 {
  font-size: 1.25rem; /* Alapértelmezett betűméret */
}

@media (min-width: 600px) {
  .responsive-display2 {
    font-size: 1.5rem; /* Közepes képernyő */
  }
}

@media (min-width: 960px) {
  .responsive-display2 {
    font-size: 1.75rem; /* Nagy képernyő */
  }
}

@media (min-width: 1264px) {
  .responsive-display2 {
    font-size: 2rem; /* Extra nagy képernyő */
  }
}
</style>